/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export enum DomainDriverCompanyTargetProgressStatusEnum {
  'DriverCompanyTargetProgressStatusProgress' = 'progress',
  'DriverCompanyTargetProgressStatusCompleted' = 'completed',
  'DriverCompanyTargetProgressStatusFailed' = 'failed',
}

export type DomainDriverCompanyTargetProgressStatus = DomainDriverCompanyTargetProgressStatusEnum